// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "ngx-cookie-service";
var SettingsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SettingsService(apiService, helperService, cookieService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.cookieService = cookieService;
    }
    /**
     * Get structure setting data from back-end
     *
     * @since 1.0.0
     *
     */
    SettingsService.prototype.getStructureView = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'condo-structures/settings/view').pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get structure setting data from back-end
     *
     * @since 1.0.0
     *
     */
    SettingsService.prototype.getStructure = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'condo-structures/settings').pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update structure with given condoStructureId with given data
     *
     * @since 1.0.0
     *
     * @param condoStructureId ID of condo structure setting to update
     * @param data New condo structure setting data
     */
    SettingsService.prototype.updateStructure = function (condoStructureId, areaId, subAreaId, data) {
        if (typeof areaId !== 'undefined' && typeof subAreaId !== 'undefined') {
            return this.apiService.apiCall('PUT', "condo-structures/settings/" + condoStructureId + "/" + areaId + "/" + subAreaId, data);
        }
        else if (typeof areaId !== 'undefined' && typeof subAreaId === 'undefined') {
            return this.apiService.apiCall('PUT', "condo-structures/settings/" + condoStructureId + "/" + areaId, data);
        }
        else {
            return this.apiService.apiCall('PUT', "condo-structures/settings/" + condoStructureId, data);
        }
    };
    /**
     * Create document with given documentId with given data
     *
     * @since 1.0.0
     *
     * @param documencondoStructureIdtId ID of document setting to update
     * @param data New document setting data
     */
    SettingsService.prototype.createStructure = function (condoStructureId, areaId, subAreaId, data) {
        if (typeof areaId !== 'undefined' && typeof subAreaId !== 'undefined') {
            return this.apiService.apiCall('POST', "condo-structures/settings/" + condoStructureId + "/" + areaId + "/" + subAreaId, data);
        }
        else if (typeof areaId !== 'undefined' && typeof subAreaId === 'undefined') {
            return this.apiService.apiCall('POST', "condo-structures/settings/" + condoStructureId + "/" + areaId, data);
        }
        else {
            return this.apiService.apiCall('POST', "condo-structures/settings/" + condoStructureId, data);
        }
    };
    /**
     * Move a second-level content (section) between two areas of the same condo-structure template.
     * The moved content is appended at the end of the destination area, preserving its _id and sub-fields.
     *
     * @since 3.0.0
     *
     * @param condoStructureId Template id (same for source and destination)
     * @param sourceAreaId     Area currently containing the content (must differ from destAreaId)
     * @param destAreaId       Destination area
     * @param contentId        Content (section) to move
     */
    SettingsService.prototype.moveCondoStructureContent = function (condoStructureId, sourceAreaId, destAreaId, contentId) {
        var data = { condoStructureId: condoStructureId, sourceAreaId: sourceAreaId, destAreaId: destAreaId, contentId: contentId };
        // v2-only endpoint: force version regardless of the environment default
        return this.apiService.apiCall('PUT', 'condo-structures/settings/move/content', data, undefined, undefined, undefined, 'v2');
    };
    /**
     * Get document setting data from back-end
     *
     * @since 1.0.0
     *
     */
    SettingsService.prototype.getDocument = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'document-archives/settings').pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update document with given documentId with given data
     *
     * @since 1.0.0
     *
     * @param documentId ID of document setting to update
     * @param data New document setting data
     */
    SettingsService.prototype.updateDocument = function (documentId, areaId, subAreaId, data) {
        if (typeof areaId !== 'undefined' && typeof subAreaId !== 'undefined') {
            return this.apiService.apiCall('PUT', "document-archives/settings/" + documentId + "/" + areaId + "/" + subAreaId, data);
        }
        else if (typeof areaId !== 'undefined' && typeof subAreaId === 'undefined') {
            return this.apiService.apiCall('PUT', "document-archives/settings/" + documentId + "/" + areaId, data);
        }
        else {
            return this.apiService.apiCall('PUT', "document-archives/settings/" + documentId, data);
        }
    };
    /**
     * Create document with given documentId with given data
     *
     * @since 1.0.0
     *
     * @param documentId ID of document setting to update
     * @param data New document setting data
     */
    SettingsService.prototype.createDocument = function (documentId, areaId, subAreaId, data) {
        if (typeof areaId !== 'undefined' && typeof subAreaId !== 'undefined') {
            return this.apiService.apiCall('POST', "document-archives/settings/" + documentId + "/" + areaId + "/" + subAreaId, data);
        }
        else if (typeof areaId !== 'undefined' && typeof subAreaId === 'undefined') {
            return this.apiService.apiCall('POST', "document-archives/settings/" + documentId + "/" + areaId, data);
        }
        else {
            return this.apiService.apiCall('POST', "document-archives/settings/" + documentId, data);
        }
    };
    /**
     * Move a second-level content (section) between two areas of the same template.
     * The moved content is appended at the end of the destination area.
     *
     * @since 3.0.0
     *
     * @param documentId   Template id (same for source and destination)
     * @param sourceAreaId Area currently containing the content
     * @param destAreaId   Destination area (must differ from sourceAreaId)
     * @param contentId    Content to move
     */
    SettingsService.prototype.moveDocumentContent = function (documentId, sourceAreaId, destAreaId, contentId) {
        var data = { documentId: documentId, sourceAreaId: sourceAreaId, destAreaId: destAreaId, contentId: contentId };
        // v2-only endpoint: force version regardless of the environment default
        return this.apiService.apiCall('PUT', 'document-archives/settings/move/content', data, undefined, undefined, undefined, 'v2');
    };
    /**
     * Move a third-level document between two contents (sections) of the same template.
     * Source and destination contents may belong to the same area or to different areas.
     * The moved document is appended at the end of the destination content.
     *
     * @since 3.0.0
     *
     * @param documentId      Template id (same for source and destination)
     * @param sourceAreaId    Area containing the source content
     * @param sourceContentId Content currently containing the document
     * @param destAreaId      Area containing the destination content
     * @param destContentId   Destination content (must differ from sourceContentId)
     * @param docId           Document to move
     */
    SettingsService.prototype.moveDocumentDocument = function (documentId, sourceAreaId, sourceContentId, destAreaId, destContentId, docId) {
        var data = {
            documentId: documentId,
            sourceAreaId: sourceAreaId,
            sourceContentId: sourceContentId,
            destAreaId: destAreaId,
            destContentId: destContentId,
            docId: docId
        };
        // v2-only endpoint: force version regardless of the environment default
        return this.apiService.apiCall('PUT', 'document-archives/settings/move/document', data, undefined, undefined, undefined, 'v2');
    };
    SettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.CookieService)); }, token: SettingsService, providedIn: "root" });
    return SettingsService;
}());
export { SettingsService };
